"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAIN_NET = exports.TEST_NET = exports.DEV_NET = exports.Network = void 0;
const web3_js_1 = require("@solana/web3.js");
var Network;
(function (Network) {
    Network[Network["DEV"] = 0] = "DEV";
    Network[Network["TEST"] = 1] = "TEST";
    Network[Network["MAIN"] = 2] = "MAIN";
    Network[Network["LOCAL"] = 3] = "LOCAL";
})(Network = exports.Network || (exports.Network = {}));
exports.DEV_NET = {
    exchange: new web3_js_1.PublicKey('HcyCw29qWC77CTnmJkwjnW1whbTppv4xh2SQQzjMin55'),
    oracle: new web3_js_1.PublicKey('DUTaRHQcejLHkDdsnR8cUUv2BakxCJfJQmWQNK2hzizE'),
    exchangeAuthority: new web3_js_1.PublicKey('6dcLU83ferGcEAjeUeLuJ8q7JbSV2vK3EGajW895tZBj')
};
exports.TEST_NET = {
    exchange: new web3_js_1.PublicKey('HcyCw29qWC77CTnmJkwjnW1whbTppv4xh2SQQzjMin55'),
    oracle: new web3_js_1.PublicKey('4nopYr9nYL5MN1zVgvQQfLhDdqAyVHtR5ZkpPcS12M5b'),
    exchangeAuthority: new web3_js_1.PublicKey('6dcLU83ferGcEAjeUeLuJ8q7JbSV2vK3EGajW895tZBj')
};
exports.MAIN_NET = {
    exchange: new web3_js_1.PublicKey('5TeGDBaMNPc2uxvx6YLDycsoxFnBuqierPt3a8Bk4xFX'),
    // oracle: new PublicKey('4nopYr9nYL5MN1zVgvQQfLhDdqAyVHtR5ZkpPcS12M5b'),
    exchangeAuthority: new web3_js_1.PublicKey('4f1XgkC1dSvvovZ9EU85pY8pwNdJRhqy7jjq188b1DjJ')
};
